<template>
  <div>
    <v-row v-if="menuData" class="mb-2 ">
      <v-col cols="" >
        <v-tabs v-model="menuTab" >
          <v-tab>Stream Meals</v-tab>
          <v-tab>Subs</v-tab>
          <v-tab>Extras</v-tab>
        </v-tabs>
      </v-col>
      <v-col class="">
        <div class="d-flex align-center justify-end">
          <div class="d-flex align-center">
            <span class="text-caption mr-2">Copy:</span>
            <v-checkbox
              v-model="copySubstitutions"
              label="Subs"
              dense
              hide-details
              class="mr-1 mt-0"
            ></v-checkbox>
            <v-checkbox
              v-model="copyExtras"
              label="Extras"
              dense
              hide-details
              class="mr-2 mt-0"
            ></v-checkbox>
          </div>
        </div>
        <div class="d-flex align-center justify-end">
          <v-checkbox
            v-model="hidePrices"
            label="Hide Prices"
            dense
            hide-details
            class="mr-2 mt-0"
          />
          <v-btn color="primary" outlined small @click="copyMenuToClipboard" class="mt-2">
            <v-icon left small>mdi-content-copy</v-icon>
            Copy Menu
          </v-btn>
        </div>
      </v-col>
    </v-row>
    <v-tabs-items v-if="menuData" v-model="menuTab">
      <v-tab-item>
        <div v-if="Object.keys(groupedRegularMeals).length > 0">
          <div v-for="(meals, date) in groupedRegularMeals" :key="date" class="mb-4">
            <v-subheader>{{ dateFormatted(date) }}</v-subheader>
            <v-list>
              <v-list-item v-for="(meal, index) in meals" :key="`${meal.id}-${index}`">
                <v-list-item-content>
                  <v-list-item-title>{{ meal.name }}</v-list-item-title>
                  <v-list-item-subtitle>
                    {{ meal.tod }} - {{ meal.stream }}
                  </v-list-item-subtitle>
                  <v-list-item-subtitle v-if="meal.ingredients && meal.ingredients.length > 0" class="mt-1 text-wrap">
                    {{ meal.ingredients }}
                  </v-list-item-subtitle>
                </v-list-item-content>
                <v-list-item-action v-if="meal.price && showRegularMealPrices">
                  <v-chip small>{{ formatCurrency(meal.price) }}</v-chip>
                </v-list-item-action>
              </v-list-item>
            </v-list>
          </div>
        </div>
        <v-alert v-else type="info" outlined>
          No stream meals available for this customer's stream.
        </v-alert>
      </v-tab-item>
      <v-tab-item>
        <div v-if="Object.keys(groupedSubstitutionMeals).length > 0">
          <div v-for="(meals, date) in groupedSubstitutionMeals" :key="date" class="mb-4">
            <v-subheader>{{ dateFormatted(date) }}</v-subheader>
            <v-list>
              <v-list-item v-for="(meal, index) in meals" :key="`${meal.id}-${index}`">
                <v-list-item-content>
                  <v-list-item-title>{{ meal.name }}</v-list-item-title>
                  <v-list-item-subtitle>
                    {{ meal.tod }} - {{ meal.stream }}
                  </v-list-item-subtitle>
                  <v-list-item-subtitle v-if="meal.ingredients && meal.ingredients.length > 0" class="mt-1 text-wrap">
                    {{ meal.ingredients }}
                    <!--                    <strong>Ingredients:</strong> {{ meal.ingredients.map(i => i.name).join(', ') }}-->
                  </v-list-item-subtitle>
                </v-list-item-content>
                <v-list-item-action v-if="meal.price && showSubstitutionPrices">
                  <v-chip small>{{ formatCurrency(meal.price) }}</v-chip>
                </v-list-item-action>
              </v-list-item>
            </v-list>
          </div>
        </div>
        <v-alert v-else type="info" outlined>
          No substitution meals available.
        </v-alert>
      </v-tab-item>
      <v-tab-item>
        <div v-if="menuData.extras && menuData.extras.length > 0">
          <v-list>
            <v-list-item v-for="(extra, index) in menuData.extras" :key="`${extra.id}-${index}`">
              <v-list-item-content>
                <v-list-item-title>{{ extra.name }}</v-list-item-title>
                <v-list-item-subtitle>
                  {{ extra.tod }}
                </v-list-item-subtitle>
                <v-list-item-subtitle v-if="extra.ingredients && extra.ingredients.length > 0" class="mt-1 text-wrap">
                  {{ extra.ingredients }}
                  <!--                    <strong>Ingredients:</strong> {{ extra.ingredients.map(i => i.name).join(', ') }}-->
                </v-list-item-subtitle>
              </v-list-item-content>
              <v-list-item-action v-if="extra.price && showExtrasPrices">
                <v-chip small>{{ formatCurrency(extra.price) }}</v-chip>
              </v-list-item-action>
            </v-list-item>
          </v-list>
        </div>
        <v-alert v-else type="info" outlined>
          No extras available.
        </v-alert>
      </v-tab-item>
    </v-tabs-items>
    <div v-if="!menuData" class="text-center">
      <v-progress-circular indeterminate/>
      <p class="mt-2">Loading menu...</p>
    </div>
  </div>
</template>

<script>
import {mapActions} from 'vuex'
import {dateFormatted, formatCurrency} from '@/store/utils'

export default {
  name: 'MenuDisplay',
  props: {
    uid: String,
    stream: String,
    dateFrom: String,
    dateTo: String,
    customerPlan: Object
  },
  data() {
    return {
      menuTab: 0,
      menuData: null,
      loading: false,
      copySuccess: false,
      hidePrices: true,
      copySubstitutions: false,
      copyExtras: false
    }
  },
  watch: {
    uid: 'fetchMenuData',
    stream: 'fetchMenuData',
    dateFrom: 'fetchMenuData',
    dateTo: 'fetchMenuData'
  },
  computed: {
    showRegularMealPrices() {
      return !this.hidePrices
    },
    showSubstitutionPrices() {
      if (this.hidePrices) return false
      return !(this.customerPlan && this.customerPlan.swap_at_plan_rate)
    },
    showExtrasPrices() {
      return true
    },
    groupedRegularMeals() {
      if (!this.menuData || !this.menuData.regularMeals) return {}
      return this.groupMealsByDate(this.menuData.regularMeals)
    },
    groupedSubstitutionMeals() {
      if (!this.menuData || !this.menuData.substitutionMeals) return {}
      return this.groupMealsByDate(this.menuData.substitutionMeals)
    }
  },
  mounted() {
    this.fetchMenuData()
  },
  methods: {
    dateFormatted,
    formatCurrency,
    ...mapActions(['fetchMenu', 'fetchPersonalMenu']),

    flattenMenu(menu) {
      return menu.flatMap(menuDate => menuDate.meals || [])
    },

    formatMealForSort(meal) {
      const todOrder = { 'breakfast': 1, 'lunch': 2, 'dinner': 3 }
      const todPriority = todOrder[meal.tod] || 4
      return `${meal.date}-${todPriority.toString().padStart(2, '0')}-${meal.name}`
    },

    groupMealsByDate(meals) {
      const grouped = {}
      meals.forEach(meal => {
        if (!grouped[meal.date]) {
          grouped[meal.date] = []
        }
        grouped[meal.date].push(meal)
      })
      
      // Sort meals within each date by time of day
      Object.keys(grouped).forEach(date => {
        grouped[date].sort((a, b) => this.formatMealForSort(a).localeCompare(this.formatMealForSort(b)))
      })
      
      return grouped
    },

    async fetchMenuData() {
      if (!this.stream || !this.dateFrom) {
        return
      }

      this.loading = true
      this.menuData = null

      try {
        const menus = await this.fetchMenu(this.dateFrom)

        const regularMeals = []
        const substitutionMeals = []
        let extras = []

        let streamMenu
        if (this.stream === 'personal') {
          streamMenu = await this.fetchPersonalMenu({date: this.dateFrom, uid: this.uid})
        } else {
          streamMenu = menus[this.stream]
        }

        if (streamMenu) {
          regularMeals.push(...this.flattenMenu(streamMenu.menu))

          Object.keys(menus).forEach(stream => {
            if (stream === this.stream) {
              // Skip current stream
            } else if (menus[stream].derived || stream === 'flex') {
              // Skip derived or flex
            } else if (stream === 'student' || stream === 'diabetes') {
              // Skip student and diabetes streams
            } else {
              substitutionMeals.push(...this.flattenMenu(menus[stream].menu))
            }
          })
        }

        if (menus.full && menus.full.menu) {
          const anyDayMenu = menus.full.menu.find(dayMenu => dayMenu.date === 'any')
          if (anyDayMenu && anyDayMenu.products) {
            extras = anyDayMenu.products
          }
        }

        regularMeals.sort((a, b) => this.formatMealForSort(a).localeCompare(this.formatMealForSort(b)))
        substitutionMeals.sort((a, b) => this.formatMealForSort(a).localeCompare(this.formatMealForSort(b)))

        this.menuData = {
          regularMeals,
          substitutionMeals,
          extras
        }
      } catch (error) {
        console.error('Failed to fetch menu data:', error)
      } finally {
        this.loading = false
      }
    },

    formatMenuAsText() {
      if (!this.menuData) return ''

      let text = `MENU\n`
      text += `${this.dateFrom ? `Date: ${this.dateFormatted(this.dateFrom)}` : ''}\n`
      text += `${this.dateTo && this.dateTo !== this.dateFrom ? ` to ${this.dateFormatted(this.dateTo)}` : ''}\n\n`

      // Stream Meals
      if (Object.keys(this.groupedRegularMeals).length > 0) {
        text += `STREAM MEALS:\n`
        text += `${'-'.repeat(50)}\n`
        Object.keys(this.groupedRegularMeals).sort().forEach(date => {
          text += `\n${this.dateFormatted(date)}:\n`
          this.groupedRegularMeals[date].forEach(meal => {
            text += `  ${meal.name} (${meal.tod})\n`
            if (meal.price && this.showRegularMealPrices) {
              text += `    Price: ${this.formatCurrency(meal.price)}\n`
            }
            if (meal.ingredients && meal.ingredients.length > 0) {
              text += `    Ingredients: ${meal.ingredients}\n`
            }
            text += `\n`
          })
        })
      }

      // Substitution Meals
      if (this.copySubstitutions && Object.keys(this.groupedSubstitutionMeals).length > 0) {
        text += `SUBSTITUTION MEALS:\n`
        text += `${'-'.repeat(50)}\n`
        Object.keys(this.groupedSubstitutionMeals).sort().forEach(date => {
          text += `\n${this.dateFormatted(date)}:\n`
          this.groupedSubstitutionMeals[date].forEach(meal => {
            text += `  ${meal.name} (${meal.tod}) - ${meal.stream}\n`
            if (meal.price && this.showSubstitutionPrices) {
              text += `    Price: ${this.formatCurrency(meal.price)}\n`
            }
            if (meal.ingredients && meal.ingredients.length > 0) {
              text += `    Ingredients: ${meal.ingredients}\n`
            }
            text += `\n`
          })
        })
      }

      // Extras
      if (this.copyExtras && this.menuData.extras && this.menuData.extras.length > 0) {
        text += `EXTRAS:\n`
        text += `${'-'.repeat(50)}\n`
        this.menuData.extras.forEach(extra => {
          text += `${extra.name}\n`
          text += `  ${extra.tod}\n`
          if (extra.price && this.showExtrasPrices) {
            text += `  Price: ${this.formatCurrency(extra.price)}\n`
          }
          if (extra.ingredients && extra.ingredients.length > 0) {
            text += `  Ingredients: ${extra.ingredients}\n`
          }
          text += `\n`
        })
      }

      return text
    },

    async copyMenuToClipboard() {
      try {
        const menuText = this.formatMenuAsText()
        await navigator.clipboard.writeText(menuText)
        this.copySuccess = true
        this.$emit('copy-success', 'Menu copied to clipboard!')
        setTimeout(() => {
          this.copySuccess = false
        }, 3000)
      } catch (error) {
        console.error('Failed to copy menu:', error)
        this.$emit('copy-error', 'Failed to copy menu to clipboard')
      }
    }
  }
}
</script>

<style scoped>
</style>